import { useState } from "react";
import { IoChevronDown } from "react-icons/io5";

const TabNavigation = ({ tabs, activeTab, onTabChange }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const activeTabLabel = tabs.find(tab => tab.id === activeTab)?.label || tabs[0].label;

  return (
    <>
      {/* Desktop tabs */}
      <div className="hidden md:block bg-white rounded-xl py-3 px-4 shadow-sm border border-gray-100 mb-6">
        <div className="flex items-center justify-between gap-2 overflow-x-auto">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                flex-1 px-4 py-1 text-sm font-medium whitespace-nowrap transition-colors relative flex justify-center
                ${
                  activeTab === tab.id
                    ? "text-black"
                    : tab.id === "more"
                    ? "text-gray-400"
                    : "text-gray-600 hover:text-gray-800"
                }
              `}
            >
              <span className="relative inline-block">
                {tab.label}
                {activeTab === tab.id && (
                  <div className="absolute bottom-[-4px] left-0 right-0 h-0.5 bg-green-600 rounded-full" />
                )}
              </span>
            </button>
          ))}
        </div>
      </div>

      {/* Mobile dropdown */}
      <div className="md:hidden bg-white rounded-xl shadow-sm border border-gray-100 mb-6 relative">
        <button
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          className="w-full flex items-center justify-between px-4 py-3 text-sm font-medium text-black"
        >
          <span>{activeTabLabel}</span>
          <IoChevronDown className={`w-4 h-4 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} />
        </button>

        {isDropdownOpen && (
          <>
            <div 
              className="fixed inset-0 z-40" 
              onClick={() => setIsDropdownOpen(false)}
            />
            <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-xl shadow-lg z-50 max-h-64 overflow-y-auto">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => {
                    onTabChange(tab.id);
                    setIsDropdownOpen(false);
                  }}
                  className={`
                    w-full text-left px-4 py-3 text-sm font-medium transition-colors
                    ${
                      activeTab === tab.id
                        ? "bg-green-50 text-black"
                        : tab.id === "more"
                        ? "text-gray-400 hover:bg-gray-50"
                        : "text-gray-600 hover:bg-gray-50"
                    }
                  `}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default TabNavigation;
